import _ from "lodash";
import { Resizable } from "re-resizable";
import React, { useMemo } from "react";
import styles from "../statics/styles-scss";
const handleStyleReset = {
  width: void 0,
  height: void 0,
  top: void 0,
  bottom: void 0,
  left: void 0,
  right: void 0
};
const handleStyles = {
  left: handleStyleReset,
  right: handleStyleReset
};
const handleClasses = {
  right: [styles.handlerRight, "ricos-resize-handler-right"].join(" "),
  left: styles.handlerLeft
};
const getEnableMap = (disabled, containerData) => {
  if (disabled) {
    return { left: false, right: false };
  }
  switch (containerData?.alignment) {
    case "LEFT":
      return { left: false, right: true };
    case "RIGHT":
      return { left: true, right: false };
    default:
      return { left: true, right: true };
  }
};
const useMaxContentWidth = (props) => {
  const { editor, decorations } = props;
  return useMemo(() => {
    const isBreakoutFullWidth = decorations.some(
      (decoration) => decoration.type?.attrs["data-breakout"] === "fullWidth"
    );
    if (isBreakoutFullWidth) {
      return editor.view.dom.clientWidth;
    }
    const editorContent = window.getComputedStyle(editor.view.dom.firstChild);
    const paddingStart = parseInt(editorContent.paddingInlineStart) || 0;
    const paddingEnd = parseInt(editorContent.paddingInlineEnd) || 0;
    return editor.view.dom.clientWidth - paddingStart - paddingEnd;
  }, [editor.view.dom.clientWidth, decorations]);
};
const ResizerHOC = (Component) => {
  return (props) => {
    const { updateAttributes, componentData, selected } = props;
    const minWidth = 15;
    const maxWidth = Math.max(minWidth, useMaxContentWidth(props));
    const enableMap = getEnableMap(!selected, componentData.containerData);
    const onResize = (_event, _direction, element) => {
      const width = parseInt(element.style.width);
      if (Number.isInteger(width)) {
        updateAttributes({
          containerData: {
            ...props.componentData.containerData,
            width: {
              custom: width
            }
          }
        });
      }
    };
    const onResizeThrottle = _.throttle(onResize, 30);
    return /* @__PURE__ */ React.createElement(
      Resizable,
      {
        "data-hook": "ricos-resizer",
        minWidth,
        maxWidth,
        size: { width: "auto", height: "auto" },
        enable: enableMap,
        className: styles.resizer,
        onResize: onResizeThrottle,
        onResizeStop: onResize,
        handleClasses,
        handleStyles
      },
      /* @__PURE__ */ React.createElement(Component, { ...props })
    );
  };
};
var resizer_default = ResizerHOC;
export {
  resizer_default as default
};
//# sourceMappingURL=resizer.js.map
